import React, { useEffect } from 'react'

import {
  presets,
  queueWrite
} from 'glitched-writer'

import "./TextAnimation.css"

const TextAnimation = ({ text }) => {
  useEffect(() => {
    const phrases = text
    queueWrite(
      phrases,
      ".textAnimation",
      {
        ...presets.neo,
        letterize: true
      },
      3000,
      true
    )
  }, [text])

  return (
    <div>
      <div className="textAnimation"></div>
    </div>
  )
}

export default TextAnimation